import React, { useState } from "react";

const JanmDakhala = () => {
  const [certificates, setCertificates] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    fatherName: "",
    motherName: "",
    birthDate: "",
    birthPlace: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    

    if (!formData.name || !formData.birthDate) {
      alert("कृपया आवश्यक माहिती भरा.");
      return;
    }

    setCertificates([...certificates, formData]);
    setFormData({
      name: "",
      fatherName: "",
      motherName: "",
      birthDate: "",
      birthPlace: "",
    });
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>जन्म दाखला (Birth Certificate)</h2>
      <p style={styles.description}>
        ग्रामपंचायतीकडून दिलेल्या जन्म प्रमाणपत्राची नोंद येथे करता येईल.
      </p>

      {/* ===== Form Section ===== */}
      <form style={styles.form} onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="मुलाचे पूर्ण नाव"
          value={formData.name}
          onChange={handleChange}
          style={styles.input}
          required
        />
        <input
          type="text"
          name="fatherName"
          placeholder="वडिलांचे नाव"
          value={formData.fatherName}
          onChange={handleChange}
          style={styles.input}
        />
        <input
          type="text"
          name="motherName"
          placeholder="आईचे नाव"
          value={formData.motherName}
          onChange={handleChange}
          style={styles.input}
        />
        <input
          type="date"
          name="birthDate"
          value={formData.birthDate}
          onChange={handleChange}
          style={styles.input}
          required
        />
        <input
          type="text"
          name="birthPlace"
          placeholder="जन्मस्थान"
          value={formData.birthPlace}
          onChange={handleChange}
          style={styles.input}
        />

        <button type="submit" style={styles.button}>
          नोंद जोडा
        </button>
      </form>

      {/* ===== Records Section ===== */}
      <div style={styles.listContainer}>
        <h3>🧾 नोंदवलेले जन्म दाखले:</h3>
        {certificates.length === 0 ? (
          <p>अजून कोणतीही नोंद नाही.</p>
        ) : (
          <ul style={styles.list}>
            {certificates.map((cert, index) => (
              <li key={index} style={styles.listItem}>
                <strong>{cert.name}</strong> — {cert.birthDate} —{" "}
                {cert.birthPlace}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#f9f9f9",
    padding: "20px",
    minHeight: "100vh",
  },
  title: {
    color: "#006400",
    textAlign: "center",
  },
  description: {
    textAlign: "center",
    marginBottom: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxWidth: "400px",
    margin: "0 auto",
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 0 8px rgba(0,0,0,0.2)",
  },
  input: {
    padding: "8px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  button: {
    backgroundColor: "#228B22",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  listContainer: {
    marginTop: "30px",
  },
  list: {
    listStyle: "none",
    paddingLeft: 0,
  },
  listItem: {
    backgroundColor: "#fff",
    padding: "10px",
    marginBottom: "8px",
    borderRadius: "5px",
    boxShadow: "0 0 4px rgba(0,0,0,0.1)",
  },
};

export default JanmDakhala;